import React, { FC } from 'react';
import Loader from 'components/UI/Loader';
import { Trans } from 'react-i18next';
import css from './styles.module.scss';

const LoadingBlock: FC = () => (
    <div className={css.loading}>
      <Loader />
      <span>
      <Trans i18nKey="reportbuilder.processGenerations" components={{ br: <br /> }} />
      </span>
    </div>
  );

export default LoadingBlock;
